<section class="container">
  <!-- The navbar for the wizard -->
  <header class="header">
    <ol>
      <ng-container *ngFor="let step of steps; let i = index;">
        <li>
            <ng-container *ngIf="step.stepLabel; else showLabelText" [ngTemplateOutlet]="step.stepLabel.template">
            </ng-container>
            <ng-template #showLabelText>
              {{ step.label  | translate}}
            </ng-template>
        </li>
      </ng-container>
    </ol>
  </header>

  <div class="body">
    <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
  </div>
</section>
